import { render, staticRenderFns } from "./_moreX.vue?vue&type=template&id=2f79f450&lang=pug&"
import script from "./_moreX.vue?vue&type=script&lang=js&"
export * from "./_moreX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports